export default __webpack_public_path__ + "static/media/LOGO_OXETECH_WORK.d7f952ed.png";